module.exports = __webpack_public_path__ + "static/img/xingNo.727fb305.svg";